__webpack_require__.p = "https://app.fashionist.tw1.ru/_next/";